// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120935/js/" + chunkId + "." + {"44":"4d45e6ef","225":"9483d9a7","481":"c674e39b","486":"86e370cf","770":"dc14f3bb"}[chunkId] + ".0.9743510881032291.chunk.js";
};